// extracted by mini-css-extract-plugin
export default {"products":"nC-z","card":"oC-z","oosMessaging":"pC-z"};